import React, { useEffect, useState } from "react";
import { Col, Container, ListGroup, Row, Spinner } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { ImageElement } from "components";

import userRouteMap from "routes/User/userRouteMap";
import { BROKER_ENDPOINT } from "apiEndpoints";
import { commonService } from "services/common.service";
import socketEventManager from "socket/socketEvents";

function ModelGallery() {
  const [state, setState] = useState({
    isLoading: true,
    lists: [],
    imagesDetails: {
      isLoading: true,
      lists: [],
      parentId: null,
      childIndex: 0,
    },
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [noChiledCategoryCase, setNoChiledCategoryCase] = useState(false);

  const getImagesList = async (id) => {
    try {
      setState((prevState) => ({
        ...prevState,
        imagesDetails: {
          ...prevState.imagesDetails,
          isLoading: true,
        },
      }));
      const response = await commonService({
        apiEndPoint: BROKER_ENDPOINT.getCategoryDetails(id),
      });
      setState((prevState) => ({
        ...prevState,
        imagesDetails: {
          ...prevState.imagesDetails,
          isLoading: false,
          lists: response?.data?.data ?? [],
          parentId: id,
          childIndex: 0,
        },
      }));
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        imagesDetails: {
          ...prevState.imagesDetails,
          isLoading: false,
        },
      }));
    }
  };

  const getCategoryDetails = async () => {
    console.log("88888888",location.state?.id)
    try {
      const response = await commonService({
        apiEndPoint: BROKER_ENDPOINT.getCategoryDetails(location.state?.id),
      });
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
        lists: response?.data?.data ?? [],
      }));

      if (response?.data?.data?.[0]) {
        getImagesList(response?.data?.data[0].id);
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };

  const handleChangeOption = (parentId, childIndex, isNoChiled) => {
    const isSameParent = parentId === state.imagesDetails.parentId;
  
    if (isNoChiled) {
      setNoChiledCategoryCase(true);
  
      if (!isSameParent) {
        setState((prevState) => ({
          ...prevState,
          imagesDetails: {
            ...prevState.imagesDetails,
            parentId,
            childIndex: 0,
          },
        }));
      }
    } else {
      setNoChiledCategoryCase(false);
  
      if (!isSameParent) {
        const newChildIndex = typeof childIndex === "number" ? childIndex : 0;
  
        setState((prevState) => ({
          ...prevState,
          imagesDetails: {
            ...prevState.imagesDetails,
            parentId,
            childIndex: newChildIndex,
            lists: [],
          },
        }));
        getImagesList(parentId);
      } else if (typeof childIndex === "number") {
        setState((prevState) => ({
          ...prevState,
          imagesDetails: {
            ...prevState.imagesDetails,
            parentId,
            childIndex,
          },
        }));
      }
    }
  };

  const handleSocketCommand = (item) => { 

    if(item?.child_category?.length < 1){
      console.log("item", item);
        const primarySocketObject = {
          hardware_id: item?.hardware_id,
          broker_id: item?.broker_id,
          sub_sub_category_id: item?.sub_sub_category_id,         
          type : "video",
          video_id : item?.primary_media_id,
          video_url : item?.primary_media,
          "action": "play",
          "video_loop": "yes",
        }
      socketEventManager.sendCommand(item?.hardware_id, primarySocketObject);
    }  
  } 
  
  useEffect(() => {
    console.log('location.state', location.state);
    if (!location.state) {
      navigate("/");
    } else {
      getCategoryDetails();
    }
  }, []);

  return (
    <div className="modelGallery">
      <Container fluid className="p-0">
        <Row className="gx-0">
          <Col md={6}>
            {state.imagesDetails.isLoading ? (
              <div className="d-flex justify-content-center align-items-center vh-100">
                <Spinner />
              </div>
            ) : !state.imagesDetails.isLoading &&
              (state.imagesDetails?.lists?.length > 0 ||
                location.state?.primary_media) ? (
              <div className="modelGallery_left commonLeftImg">
                {/* <div className="boxImage">
                  <ImageElement
                    imageFor="user"
                    previewSource={
                      state.imagesDetails?.lists?.[
                        state.imagesDetails.childIndex
                      ]?.primary_media ?? location.state?.primary_media
                    }
                    className="w-100"
                    alt="modal-gallery"
                  />
                </div> */}
                <div className="boxImage">
                  {console.log('noChiledCategoryCase', noChiledCategoryCase)}
                  {/*  eslint-disable-next-line jsx-a11y/media-has-caption */}
                  {
                    noChiledCategoryCase ? (

                      //  eslint-disable-next-line jsx-a11y/media-has-caption
                      <video
                        key={
                          noChiledCategoryCase
                            ? state?.lists?.find(item => item.id === state.imagesDetails.parentId)?.primary_media
                            : state.imagesDetails?.lists?.[state.imagesDetails.childIndex]?.primary_media
                        }
                        controls
                        loop={state.isLoop}
                        autoPlay
                        className="mw-100 w-100"
                      >
                        <source
                          src={
                            noChiledCategoryCase
                              ? state?.lists?.find(item => item.id === state.imagesDetails.parentId)?.primary_media
                              : state.imagesDetails?.lists?.[state.imagesDetails.childIndex]?.primary_media
                          }
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      //  eslint-disable-next-line jsx-a11y/media-has-caption
                      <video
                        controls
                        key={state.imagesDetails?.lists?.[state.imagesDetails.childIndex]?.primary_media || 'fallback-child'}
                        loop={state.isLoop}
                        autoPlay
                        className="mw-100 w-100"
                      >
                        <source
                          src={
                            state.imagesDetails?.lists?.[
                              state.imagesDetails.childIndex
                            ]?.primary_media ?? location.state?.primary_media
                          }
                          type="video/mp4"
                        />
                      </video>
                    )
                  }
                  {/* <video
                    controls
                    key={state.imagesDetails?.lists?.[state.imagesDetails.childIndex]?.primary_media}
                    loop={state.isLoop}
                    autoPlay
                    className="mw-100 w-100 h-100 object-fit-cover"
                  >
                    <source
                      src={
                        state.imagesDetails?.lists?.[
                          state.imagesDetails.childIndex
                        ]?.primary_media ?? location.state?.primary_media
                      }
                      type="video/mp4"
                    />
                  </video> */}
                </div>
              </div>
            ) : (
              <div className="d-flex justify-content-center align-items-center vh-100">
                No data found
              </div>
            )}
          </Col>
          <Col md={6}>
            <div className="modelGallery_right d-flex flex-column justify-content-between align-items-center h-100vh">
              <header className="header w-100 d-flex align-items-center position-relative">
                <div className="header_title mx-auto">
                  <h1 className="mb-0">Model Gallery</h1>
                </div>
                <Link className="header_logo" to={userRouteMap.LANDING.path}>
                  <ImageElement
                    imageFor="user"
                    source="logo.svg"
                    className="img-fluid"
                  />
                </Link>
              </header>
              <div
                className={
                  !state.isLoading
                    ? "multiList text-center innerScroll px-3"
                    : ""
                }
              >
                {state.isLoading ? (
                  <div className="d-flex justify-content-center align-items-center m-auto">
                    <Spinner />
                  </div>
                ) : !state.isLoading && state.lists.length > 0 ? (
                  <div className="landingPage_right_menu text-center innerScroll px-3">
                    <>
                      <ListGroup className="flex-column">
                        {state.lists.map((listItem, idx) => (
                          <ListGroup.Item className="multiList_item" key={idx}>
                            <Link                              
                              className={`multiList_item_tab ${state.imagesDetails.parentId === listItem?.id
                                ? "active-heading"
                                : ""
                                }`}
                              onClick={(e) => {
                                e.preventDefault();
                                if (listItem?.category_type === "property") {
                                  navigate(userRouteMap.MEETINGFLOORPLAN.path, {
                                    state: listItem,
                                  });
                                } else if (listItem?.child_category?.length > 0) {
                                  handleChangeOption(listItem?.id);
                                } else if (listItem?.child_category?.length === 0 && listItem?.primary_media) {
                                  setNoChiledCategoryCase(true);
                                  handleChangeOption(listItem?.id, '', true);
                                }
                                handleSocketCommand(listItem)
                              }}
                            >
                              {listItem.name}
                            </Link>

                            {listItem?.child_category?.length > 0 && (
                              <div className="d-flex flex-wrap subList justify-content-center">
                                {listItem.child_category.map(
                                  (childItem, childItemIdx) => (
                                    <Link
                                      key={childItemIdx}
                                      className={`subList_tab ${state.imagesDetails.parentId ===
                                        listItem?.id &&
                                        state.imagesDetails.childIndex ===
                                        childItemIdx
                                        ? "active"
                                        : ""
                                        }`}
                                      onClick={() => {
                                        handleChangeOption(
                                          listItem?.id,
                                          childItemIdx,
                                        )
                                        handleSocketCommand(childItem)
                                      }
                                      }
                                    >
                                      {childItem.name}
                                    </Link>
                                  ),
                                )}
                              </div>
                            )}
                          </ListGroup.Item>
                        ))}
                      </ListGroup>
                    </>
                  </div>
                ) : (
                  <div className="d-flex justify-content-center align-items-center vh-100">
                    No data found
                  </div>
                )}
              </div>
              <Link className="commonBack text-uppercase d-block h-auto" to="/">
                <em className="icon-back" />
                <span className="d-block">Back</span>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ModelGallery;
